function eventsCollection() {


    let eventsCollection                    = document.querySelector('.event-collection');
    let eventsCollectionItems               = eventsCollection.querySelectorAll('.event-collection-item');
    let eventCollectionItemHeight           = eventsCollection.querySelector('.event-collection-item').clientHeight;
    let eventCollectionItemImgHeight           = eventsCollection.querySelector('.event-collection-item .event-collection-item-img').clientHeight;
    let eventCollectionItemContentHeight    = eventsCollection.querySelector('.event-collection-item .event-collection-content').clientHeight;
    
    eventsCollectionItems.forEach(eventsCollectionItem => {



        if(!isMobile) {


            let eventCollectionItemContent = eventsCollectionItem.querySelector('.event-collection-content');
            let masterTl = new gsap.timeline({paused:true});
            masterTl.from(eventsCollectionItem, {y: '4rem', alpha: 0, duration: 0.8,  ease: 'power1.easeOut'});
            masterTl.to(eventsCollectionItem, {height: eventCollectionItemHeight+eventCollectionItemContentHeight+'px', duration:1,ease: 'power2.out', onComplete: function(){

                eventCollectionItemContent.style.position = 'relative';

            }});


        
            const configScrollAnimation = {
            // pin:true,
            trigger: eventsCollectionItem,
            animation: masterTl,
            //scrub:1,
            start: 'top 85%',
            //end:  'top 55%',
            onEnter: ()=>{
            masterTl.play();
            }
            }

            ScrollTrigger.create(configScrollAnimation);
        }


    });

    /*

    function fixHeight() {

        eventCollectionItemImgHeight           = eventsCollection.querySelector('.event-collection-item .event-collection-item-img').clientHeight;
        eventCollectionItemContentHeight        = eventsCollection.querySelector('.event-collection-item .event-collection-content').clientHeight;

        eventsCollectionItems.forEach(eventsCollectionItem => {
            gsap.set(eventsCollectionItem, {height: eventCollectionItemImgHeight+eventCollectionItemContentHeight+'px'});
        });


    }
    window.addEventListener("resize", debounce( fixHeight, 150 ));
    */




}